import { FormFeedBack } from '@repo/ui';
import { FormikValues } from 'formik';
import { Col, Input, Label } from 'reactstrap';
import { InputType } from 'reactstrap/types/lib/Input';

interface PersonFormInputProps {
  validation: FormikValues;
  name: string;
  label: string;
  md?: number;
  type?: InputType;
}

export const PersonFormInput = ({
  validation,
  name,
  label,
  type = 'text',
  md = 4,
}: PersonFormInputProps) => {
  const error = validation.errors[name];
  const touched = validation.touched[name];
  const value = validation.values[name];

  return (
    <Col md={md}>
      <Label htmlFor={name} className="form-label">
        {label}
      </Label>
      <Input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={validation.handleChange}
        onBlur={validation.handleBlur}
        invalid={!!(touched && error)}
      />
      <FormFeedBack error={error} isInvalid={!!(touched && error)} />
    </Col>
  );
};
